(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["localization-switcher"] && !Shopify.designMode) return;
  try {
    const switchers = document.querySelectorAll('[data-localization-switcher]');
  if (switchers.length) {
    const supportsViewTransition = typeof document.startViewTransition === 'function';
    switchers.forEach((switcher) => {
      const detailsItems = Array.from(switcher.querySelectorAll('[data-localization-details]'));
      detailsItems.forEach((details) => {
        const summary = details.querySelector('summary');
        if (!summary) return;
        summary.addEventListener('click', (event) => {
          if (!supportsViewTransition) return;
          event.preventDefault();
          const willOpen = !details.open;
          document.startViewTransition(() => {
            details.open = willOpen;
            if (willOpen) {
              detailsItems.forEach((other) => {
                if (other === details) return;
                other.open = false;
              });
            }
          });
        });
      });

      switcher.addEventListener('click', (event) => {
        const option = event.target.closest('button[type="submit"]');
        if (!option) return;
        detailsItems.forEach((details) => {
          details.open = false;
        });
      });

      document.addEventListener('click', (event) => {
        if (switcher.contains(event.target)) return;
        detailsItems.forEach((details) => {
          details.open = false;
        });
      });
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    (function() {
    document.addEventListener('click', (event) => {
      const btn = event.target.closest('[data-quick-add-btn]');
      if (!btn) return;

      event.preventDefault();
      event.stopPropagation();

      const variantId = btn.dataset.variantId;
      if (!variantId) return;

      btn.classList.add('is-loading');
      btn.disabled = true;

      const formData = new FormData();
      formData.append('id', variantId);
      formData.append('quantity', 1);

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: formData,
      })
        .then((res) => res.json())
        .then((data) => {
          btn.classList.remove('is-loading');
          btn.classList.add('is-success');

          const counter = document.querySelector('.header__cart-count');
          fetch('/cart.js')
            .then((res) => res.json())
            .then((cart) => {
              if (counter) {
                counter.textContent = cart.item_count;
                counter.hidden = cart.item_count === 0;
              }

              document.dispatchEvent(
                new CustomEvent('cart-notification:show', {
                  detail: {
                    title: btn.dataset.productTitle || '',
                    variant: btn.dataset.productVariant || '',
                    price: btn.dataset.productPrice || '',
                    image: btn.dataset.productImage || ''
                  }
                })
              );

              document.dispatchEvent(
                new CustomEvent('dispatch:cart-drawer:refresh', {
                  detail: { open: false, cart, opener: btn }
                })
              );
            });

          setTimeout(() => {
            btn.classList.remove('is-success');
            btn.disabled = false;
          }, 1500);
        })
        .catch((err) => {
          console.error('Add to cart error', err);
          btn.classList.remove('is-loading');
          btn.disabled = false;
        });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["quantity-selector"] && !Shopify.designMode) return;
  try {
    (() => {
    const containers = document.querySelectorAll('[data-quantity]');
    containers.forEach((container) => {
      const input = container.querySelector('[data-quantity-input]');
      const decrease = container.querySelector('[data-quantity-decrease]');
      const increase = container.querySelector('[data-quantity-increase]');

      if (!input || !decrease || !increase) return;

      const clamp = (value) => {
        const min = parseInt(input.min || '1', 10);
        const max = input.max ? parseInt(input.max, 10) : null;
        if (isNaN(value)) return min;
        if (max && value > max) return max;
        if (value < min) return min;
        return value;
      };

      decrease.addEventListener('click', () => {
        const step = parseInt(input.step || '1', 10);
        const next = clamp(parseInt(input.value || '0', 10) - step);
        input.value = next;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });

      increase.addEventListener('click', () => {
        const step = parseInt(input.step || '1', 10);
        const next = clamp(parseInt(input.value || '0', 10) + step);
        input.value = next;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });

      input.addEventListener('input', () => {
        // Optional: validate on blur instead of input to allow typing
      });
      
      input.addEventListener('change', () => {
         input.value = clamp(parseInt(input.value || '0', 10));
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["quick-add-modal"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
    const modal = document.getElementById('QuickAddModal');
    const content = document.getElementById('QuickAddContent');
    if (!modal || !content) return;

    const closeBtns = modal.querySelectorAll('[data-modal-close]');
    
    function closeModal() {
      modal.setAttribute('aria-hidden', 'true');
      setTimeout(() => {
        content.innerHTML = '';
      }, 300);
      document.body.style.overflow = '';
    }

    function formatMoney(cents) {
      if (window.Shopify && Shopify.formatMoney) {
        return Shopify.formatMoney(cents, window.Shopify.money_format);
      }
      return (cents / 100).toFixed(2);
    }

    function setActiveMedia(root, mediaId) {
      if (!root || !mediaId) return;
      const items = root.querySelectorAll('[data-media-item]');
      const thumbs = root.querySelectorAll('[data-media-thumb]');
      let found = false;

      items.forEach((item) => {
        const isHidden = item.classList.contains('is-hidden');
        const isActive = !isHidden && item.dataset.mediaId === String(mediaId);
        item.classList.toggle('is-active', isActive);
        if (isActive) found = true;
      });

      thumbs.forEach((thumb) => {
        const isHidden = thumb.classList.contains('is-hidden');
        thumb.classList.toggle('is-active', !isHidden && thumb.dataset.mediaId === String(mediaId));
      });

      if (!found && items.length) {
        const visibleItems = Array.from(items).filter((item) => !item.classList.contains('is-hidden'));
        visibleItems.forEach((item, index) => {
          item.classList.toggle('is-active', index === 0);
        });
        const visibleThumbs = Array.from(thumbs).filter((thumb) => !thumb.classList.contains('is-hidden'));
        visibleThumbs.forEach((thumb, index) => {
          thumb.classList.toggle('is-active', index === 0);
        });
      }
    }

    function initQuickAdd(container) {
      const root = container.querySelector('[data-quick-add]');
      if (!root || root.dataset.quickAddReady === 'true') return;
      root.dataset.quickAddReady = 'true';

      const productData = root.querySelector('[type="application/json"][data-quick-add-product-json]');
      const variantMediaMapData = root.querySelector('[type="application/json"][data-variant-media-map]');
      const product = productData ? JSON.parse(productData.textContent) : null;
      const variantMediaMap = variantMediaMapData ? JSON.parse(variantMediaMapData.textContent) : {};
      if (!product) return;

      const optionButtons = root.querySelectorAll('[data-option-index][data-option-value]');
      const optionValueLabels = root.querySelectorAll('[data-option-value-label]');
      const idInput = root.querySelector('[data-variant-id-input]');
      const priceRegular = root.querySelector('[data-regular-price]');
      const priceCompare = root.querySelector('[data-compare-price]');
      const addButton = root.querySelector('[data-add-to-cart]');
      const addButtonText = root.querySelector('[data-add-to-cart-text]');
      const form = root.querySelector('form');
      const mediaThumbs = root.querySelectorAll('[data-media-thumb]');

      const addText = root.dataset.addToCartText || '';
      const unavailableText = root.dataset.unavailableText || '';
      const addSuccess = root.dataset.addSuccess || '';
      const addLoadingText = root.dataset.addLoadingText || '';

      const optionCount = product.options ? product.options.length : 0;
      let selectedOptions = product.selected_or_first_available_variant
        ? [...product.selected_or_first_available_variant.options]
        : new Array(optionCount).fill(null);

      if (!selectedOptions.length && optionCount) {
        selectedOptions = new Array(optionCount).fill(null);
        optionButtons.forEach((btn) => {
          if (btn.classList.contains('is-active')) {
            const index = parseInt(btn.dataset.optionIndex, 10);
            selectedOptions[index] = btn.dataset.optionValue;
          }
        });
      }

      function findVariant() {
        if (!product.variants || !product.variants.length) return null;
        return product.variants.find((variant) => {
          return variant.options.every((value, index) => value === selectedOptions[index]);
        });
      }

      function updatePrice(variant) {
        if (!variant || !priceRegular) return;
        priceRegular.textContent = formatMoney(variant.price);
        if (!priceCompare) return;
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          priceCompare.textContent = formatMoney(variant.compare_at_price);
          priceCompare.hidden = false;
        } else {
          priceCompare.hidden = true;
        }
      }

      function updateAvailability(variant) {
        if (!addButton || !addButtonText) return;
        if (variant && variant.available) {
          addButton.disabled = false;
          addButton.classList.remove('is-disabled');
          if (addText) addButtonText.textContent = addText;
          return;
        }
        addButton.disabled = true;
        addButton.classList.add('is-disabled');
        if (unavailableText) addButtonText.textContent = unavailableText;
      }

      function getVariantMediaIds(variant) {
        if (!variant) return [];
        const mapping = variantMediaMap[variant.id];
        if (mapping && mapping.media_ids && mapping.media_ids.length > 0) {
          return mapping.media_ids;
        }
        if (variant.featured_media && variant.featured_media.id) {
          return [variant.featured_media.id];
        }
        return product.media ? product.media.map((media) => media.id) : [];
      }

      function filterMediaByVariant(variant) {
        if (!variant) return;
        const mediaIds = getVariantMediaIds(variant);
        const items = root.querySelectorAll('[data-media-item]');
        const thumbs = root.querySelectorAll('[data-media-thumb]');

        items.forEach((item) => {
          const id = parseInt(item.dataset.mediaId, 10);
          const isVisible = mediaIds.includes(id);
          item.classList.toggle('is-hidden', !isVisible);
          item.classList.remove('is-active');
        });

        thumbs.forEach((thumb) => {
          const id = parseInt(thumb.dataset.mediaId, 10);
          const isVisible = mediaIds.includes(id);
          thumb.classList.toggle('is-hidden', !isVisible);
          thumb.classList.remove('is-active');
        });

        const featuredId = variant.featured_media && variant.featured_media.id ? variant.featured_media.id : null;
        const nextActive = featuredId || (mediaIds.length ? mediaIds[0] : null);
        if (nextActive) setActiveMedia(root, nextActive);
      }

      function setVariant(variant) {
        if (!variant) return;
        if (idInput) idInput.value = variant.id;

        optionButtons.forEach((btn) => {
          const optionIndex = parseInt(btn.dataset.optionIndex, 10);
          const optionValue = btn.dataset.optionValue;
          btn.classList.toggle('is-active', variant.options[optionIndex] === optionValue);
        });

        optionValueLabels.forEach((label, index) => {
          if (variant.options[index]) label.textContent = variant.options[index];
        });

        updatePrice(variant);
        updateAvailability(variant);
        filterMediaByVariant(variant);

        if (variant.featured_media && variant.featured_media.id) {
          setActiveMedia(root, variant.featured_media.id);
        }
      }

      function handleOptionChange(index, value) {
        selectedOptions[index] = value;
        const variant = findVariant();
        if (variant) {
          setVariant(variant);
          return;
        }
        updateAvailability(null);
        if (optionValueLabels[index]) {
          optionValueLabels[index].textContent = value;
        }
      }

      optionButtons.forEach((btn) => {
        btn.addEventListener('click', () => {
          const optionIndex = parseInt(btn.dataset.optionIndex, 10);
          const optionValue = btn.dataset.optionValue;
          root.querySelectorAll(`[data-option-index=\"${optionIndex}\"]`).forEach((el) => {
            el.classList.remove('is-active');
          });
          btn.classList.add('is-active');
          handleOptionChange(optionIndex, optionValue);
        });
      });

      mediaThumbs.forEach((thumb) => {
        thumb.addEventListener('click', () => {
          if (!thumb.dataset.mediaId) return;
          setActiveMedia(root, thumb.dataset.mediaId);
        });
      });

      if (product.selected_or_first_available_variant) {
        setVariant(product.selected_or_first_available_variant);
      }

      if (form) {
        form.addEventListener('submit', (event) => {
          event.preventDefault();
          if (addButton) {
            addButton.classList.add('is-loading');
            addButton.disabled = true;
          }
          if (addButtonText && addLoadingText) addButtonText.textContent = addLoadingText;

          const formData = new FormData(form);
          fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: { Accept: 'application/json' },
            body: formData
          })
            .then((res) => {
              if (!res.ok) {
                return res.json().then((error) => Promise.reject(error));
              }
              return res.json();
            })
            .then(() => fetch('/cart.js'))
            .then((res) => res.json())
            .then((cart) => {
              if (addButton) {
                addButton.classList.remove('is-loading');
                addButton.disabled = false;
              }
              if (addButtonText && addText) addButtonText.textContent = addText;

              const count = document.querySelector('.header__cart-count');
              if (count) {
                count.textContent = cart.item_count;
                count.hidden = cart.item_count === 0;
              }

              const currentVariant = findVariant();
              let variantTitle = '';
              if (currentVariant && product.options && product.options.length > 0) {
                if (!(product.options.length === 1 && product.options[0] === 'Title')) {
                  variantTitle = currentVariant.title || '';
                }
              }

              let productImage = '';
              if (currentVariant && currentVariant.featured_image && currentVariant.featured_image.src) {
                productImage = currentVariant.featured_image.src.replace(/(\.[^.]+)$/, '_120x160_crop_center$1');
              } else if (product.featured_image) {
                const imgSrc = typeof product.featured_image === 'string' ? product.featured_image : product.featured_image.src;
                if (imgSrc) {
                  productImage = imgSrc.replace(/(\.[^.]+)$/, '_120x160_crop_center$1');
                }
              }

              document.dispatchEvent(
                new CustomEvent('cart-notification:show', {
                  detail: {
                    title: product.title || '',
                    variant: variantTitle,
                    price: currentVariant ? formatMoney(currentVariant.price) : '',
                    image: productImage
                  }
                })
              );

              document.dispatchEvent(
                new CustomEvent('dispatch:cart-drawer:refresh', {
                  detail: { open: false, cart, opener: addButton }
                })
              );

              closeModal();
            })
            .catch((err) => {
              console.error(err);
              if (addButton) {
                addButton.classList.remove('is-loading');
                addButton.disabled = false;
              }
              if (addButtonText && addText) addButtonText.textContent = addText;
            });
        });
      }
    }

    closeBtns.forEach((btn) => btn.addEventListener('click', closeModal));

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && modal.getAttribute('aria-hidden') === 'false') {
        closeModal();
      }
    });

    document.addEventListener('click', (e) => {
      const trigger = e.target.closest('[data-quick-view-url]');
      if (!trigger) return;

      e.preventDefault();
      const url = trigger.dataset.quickViewUrl;
      
      modal.setAttribute('aria-hidden', 'false');
      modal.classList.add('is-loading');
      document.body.style.overflow = 'hidden';

      const errorText = modal.dataset.errorText || '';

      fetch(url)
        .then(res => res.text())
        .then(text => {
          content.innerHTML = text;
          initQuickAdd(content);
          modal.classList.remove('is-loading');

          const event = new CustomEvent('quick-add:loaded', { detail: { container: content } });
          document.dispatchEvent(event);
        })
        .catch(err => {
          console.error('Error fetching quick view:', err);
          modal.classList.remove('is-loading');
          const message = document.createElement('p');
          message.className = 'text-center p-4';
          message.textContent = errorText;
          content.innerHTML = '';
          content.appendChild(message);
        });
    });

    document.addEventListener('quick-add:loaded', (event) => {
      if (event.detail && event.detail.container) {
        initQuickAdd(event.detail.container);
      }
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["scroll-animations"] && !Shopify.designMode) return;
  try {
    (function() {
    'use strict';

    // Check for reduced motion preference
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (prefersReducedMotion) return;

    // ==========================================================================
    // Intersection Observer for Scroll Animations
    // ==========================================================================

    const observerOptions = {
      root: null,
      rootMargin: '0px 0px -60px 0px',
      threshold: 0.12
    };

    const animationObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          
          // For stagger containers, also mark children
          if (entry.target.classList.contains('anim-stagger')) {
            const children = entry.target.children;
            Array.from(children).forEach((child, index) => {
              child.style.setProperty('--stagger-index', index);
            });
          }
          
          // Unobserve after animation (one-time reveal)
          animationObserver.unobserve(entry.target);
        }
      });
    }, observerOptions);

    // Observer for individual stagger items (product cards, collection cards)
    const itemObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          itemObserver.unobserve(entry.target);
        }
      });
    }, {
      root: null,
      rootMargin: '0px 0px -40px 0px',
      threshold: 0.1
    });

    // Observe all animation targets
    function initScrollAnimations() {
      // Fade-in elements
      document.querySelectorAll('.anim-fade-in').forEach(el => {
        animationObserver.observe(el);
      });

      // Stagger containers
      document.querySelectorAll('.anim-stagger').forEach(el => {
        // Pre-set stagger indices
        Array.from(el.children).forEach((child, index) => {
          child.style.setProperty('--stagger-index', index);
        });
        animationObserver.observe(el);
      });

      // Line draw elements
      document.querySelectorAll('.anim-line-draw').forEach(el => {
        animationObserver.observe(el);
      });

      // Individual stagger items
      document.querySelectorAll('.anim-stagger-item').forEach(el => {
        itemObserver.observe(el);
      });
    }

    // ==========================================================================
    // Parallax Scrolling Effect
    // Smooth parallax for banner images
    // ==========================================================================

    const parallaxElements = [];

    function initParallax() {
      document.querySelectorAll('[data-parallax]').forEach(el => {
        const speed = parseFloat(el.dataset.parallax) || 0.15;
        parallaxElements.push({ el, speed });
      });

      if (parallaxElements.length > 0) {
        updateParallax();
        window.addEventListener('scroll', throttle(updateParallax, 10), { passive: true });
      }
    }

    function updateParallax() {
      const scrollY = window.scrollY;
      const viewportHeight = window.innerHeight;

      parallaxElements.forEach(({ el, speed }) => {
        const rect = el.getBoundingClientRect();
        const elementTop = rect.top + scrollY;
        const elementHeight = rect.height;

        // Only animate when element is in viewport
        if (scrollY + viewportHeight > elementTop && scrollY < elementTop + elementHeight) {
          const relativeScroll = scrollY - elementTop + viewportHeight;
          const offset = (relativeScroll * speed) - (viewportHeight * speed * 0.5);
          el.style.transform = `translate3d(0, ${offset}px, 0)`;
        }
      });
    }

    // Throttle helper for performance
    function throttle(fn, wait) {
      let lastTime = 0;
      return function(...args) {
        const now = Date.now();
        if (now - lastTime >= wait) {
          lastTime = now;
          fn.apply(this, args);
        }
      };
    }

    // ==========================================================================
    // Initialize on DOM Ready
    // ==========================================================================

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => {
        initScrollAnimations();
        initParallax();
      });
    } else {
      initScrollAnimations();
      initParallax();
    }

    // Re-init on Shopify section load (for theme editor)
    document.addEventListener('shopify:section:load', () => {
      initScrollAnimations();
      initParallax();
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["search-drawer"] && !Shopify.designMode) return;
  try {
    class SearchDrawer {
    constructor() {
      this.drawer = document.getElementById('SearchDrawer');
      if (!this.drawer) return;

      this.input = this.drawer.querySelector('#SearchDrawerInput');
      this.resultsContainer = this.drawer.querySelector('[data-search-results-container]');
      this.results = this.drawer.querySelector('[data-search-results]');
      this.loading = this.drawer.querySelector('[data-search-loading]');
      this.closeBtns = this.drawer.querySelectorAll('[data-search-close]');
      this.openBtns = document.querySelectorAll('.header__action-link--search, [data-search-open]');

      this.init();
    }

    init() {
      this.openBtns.forEach(btn => {
        btn.addEventListener('click', (e) => {
          e.preventDefault();
          this.open();
        });
      });

      this.closeBtns.forEach(btn => {
        btn.addEventListener('click', () => this.close());
      });

      this.input.addEventListener('input', this.debounce(() => this.onInput(), 300));

      // Close on escape
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && this.drawer.classList.contains('is-open')) {
          this.close();
        }
      });
    }

    open() {
      this.drawer.hidden = false;
      setTimeout(() => {
        this.drawer.classList.add('is-open');
        document.documentElement.classList.add('search-drawer-open');
        document.body.classList.add('search-drawer-open');
        this.input.focus();
      }, 10);
    }

    close() {
      this.drawer.classList.remove('is-open');
      document.documentElement.classList.remove('search-drawer-open');
      document.body.classList.remove('search-drawer-open');
      this.resultsContainer.hidden = true;
      this.input.value = '';
      this.results.innerHTML = '';
      setTimeout(() => {
        if (!this.drawer.classList.contains('is-open')) {
          this.drawer.hidden = true;
        }
      }, 350);
    }

    debounce(fn, wait) {
      let t;
      return (...args) => {
        clearTimeout(t);
        t = setTimeout(() => fn.apply(this, args), wait);
      };
    }

    onInput() {
      const query = this.input.value.trim();
      if (query.length < 2) {
        this.resultsContainer.hidden = true;
        this.results.innerHTML = '';
        return;
      }

      this.resultsContainer.hidden = false;
      this.fetchResults(query);
    }

    async fetchResults(query) {
      this.loading.hidden = false;

      try {
        const sectionResponse = await fetch(`${window.Shopify.routes.predictive_search_url}?q=${encodeURIComponent(query)}&resources[type]=product,article,page&resources[limit]=4&section_id=predictive-search`);
        const sectionHtml = await sectionResponse.text();

        const parser = new DOMParser();
        const doc = parser.parseFromString(sectionHtml, 'text/html');
        const results = doc.querySelector('[data-predictive-search-results]');

        if (results) {
          this.results.innerHTML = results.innerHTML;
          // Make animated items visible immediately (they bypass IntersectionObserver)
          this.results.querySelectorAll('.anim-stagger-item, .anim-fade-in').forEach(el => {
            el.classList.add('is-visible');
          });
        } else {
          this.results.innerHTML = '<p class="search-drawer__no-results">' + (window.searchNoResultsText || 'Keine Ergebnisse gefunden.') + '</p>';
        }
      } catch (e) {
        console.error('Search error:', e);
      } finally {
        this.loading.hidden = true;
      }
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    new SearchDrawer();
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["toast"] && !Shopify.designMode) return;
  try {
    (() => {
    const container = document.querySelector('[data-toast-container]');
    if (!container) return;

    const TOAST_DURATION = 3000;
    const HIDE_DURATION = 300;
    let activeToasts = [];

    function createIcon(type) {
      const iconWrapper = document.createElement('span');
      iconWrapper.className = 'toast__icon';

      if (type === 'success') {
        iconWrapper.innerHTML = `<svg viewBox="0 0 24 24"><polyline points="20 6 9 17 4 12"></polyline></svg>`;
      } else if (type === 'error') {
        iconWrapper.innerHTML = `<svg viewBox="0 0 24 24"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>`;
      }

      return iconWrapper;
    }

    function showToast(message, type = 'success') {
      const toast = document.createElement('div');
      toast.className = `toast toast--${type}`;
      toast.setAttribute('role', 'status');
      toast.setAttribute('aria-live', 'polite');

      const icon = createIcon(type);
      const text = document.createElement('span');
      text.textContent = message;

      toast.appendChild(icon);
      toast.appendChild(text);
      container.appendChild(toast);

      activeToasts.push(toast);

      // Trigger animation
      requestAnimationFrame(() => {
        toast.classList.add('is-visible');
      });

      // Auto-hide after duration
      setTimeout(() => {
        hideToast(toast);
      }, TOAST_DURATION);
    }

    function hideToast(toast) {
      toast.classList.add('is-hiding');

      setTimeout(() => {
        toast.remove();
        activeToasts = activeToasts.filter(t => t !== toast);
      }, HIDE_DURATION);
    }

    // Listen for toast events
    document.addEventListener('toast:show', (event) => {
      const { message, type = 'success' } = event.detail || {};
      if (message) {
        showToast(message, type);
      }
    });

    // Expose globally for direct access
    window.AbayaStoreToast = { showToast };
  })();
  } catch(e) { console.error(e); }
})();

})();
